import { useEffect, useState } from 'react'

import { AdminSliderPanel } from '@/components/AdminSliderPanel'
import { AdminButton } from '@/components/shared/AdminButton'
import { AdminCode } from '@/components/shared/AdminCode'
import { AdminSelect } from '@/components/shared/AdminSelect'
import {
  type SerializeLoadArgs,
  useSerializeLoad,
} from '@/hooks/useSerializeLoad'

export function SerializeSlider(args: SerializeLoadArgs) {
  const [isOpen, setIsOpen] = useState(false)
  const serializeLoad = useSerializeLoad(args, isOpen)
  const [currentCode, setCurrentCode] = useState('all')
  const data: any = serializeLoad.data
  const [carrierCodeOptions, setCarrierCodeOptions] = useState<string[]>([
    'all',
  ])

  useEffect(() => {
    if (data) {
      const credArray =
        data.carrierCredentials?.map((c: any) => c.credential) ||
        data.credentials
      if (!credArray || !Array.isArray(credArray)) return

      setCarrierCodeOptions([
        'all',
        ...credArray.map((c: any) => c.code).sort(),
      ])
    }
  }, [data])

  return (
    <>
      <AdminButton
        icon="code"
        onClick={() => setIsOpen(true)}
        className="btn-sm ml-auto!"
      />
      <AdminSliderPanel
        title={`Serialized for ${args.output}`}
        onClose={() => setIsOpen(false)}
        isOpen={isOpen}
        width="60rem"
      >
        <div className="flex flex-col gap-2">
          <AdminSelect
            name="carrierCode"
            className="select-sm"
            options={carrierCodeOptions}
            value={currentCode}
            onChange={e => setCurrentCode(e.target.value)}
          />

          {serializeLoad.isLoading && <div>Loading...</div>}
          {!!serializeLoad.data && (
            <AdminCode data={filterCreds(data, currentCode)} />
          )}
        </div>
      </AdminSliderPanel>
    </>
  )
}

function filterCreds(data: any, carrier: string) {
  if (!data || carrier === 'all') return data

  return {
    ...data,
    ...(data.carrierCredentials && {
      carrierCredentials: data.carrierCredentials.filter(
        (c: any) => c.credential.code === carrier,
      ),
    }),
    ...(data.credentials && {
      credentials: data.credentials.filter((c: any) => c.code === carrier),
    }),
  }
}
